;var assign;
((assign = require("./selection"), exports.Selection = assign.Selection, exports.TextSelection = assign.TextSelection, exports.NodeSelection = assign.NodeSelection))

;var assign$1;
((assign$1 = require("./transform"), exports.EditorTransform = assign$1.EditorTransform, exports.extendTransformAction = assign$1.extendTransformAction))

exports.EditorState = require("./state").EditorState

;var assign$2;
((assign$2 = require("./plugin"), exports.Plugin = assign$2.Plugin, exports.PluginKey = assign$2.PluginKey))



//////////////////
// WEBPACK FOOTER
// ../~/prosemirror-state/dist/index.js
// module id = 26
// module chunks = 0